import { Z_INDEX_NAV_COMPONENT_LOW } from '../../constants/z_index';
import { defineComponent } from 'navigation-components/platform/models';
import { capabilities } from '../../capabilities';
import { getPortalId } from '../../common/utils';
import { CALLING_COMPONENT } from '../constants';
const CALLING_REDESIGN_GATE = 'Calling:Rep:Redesign';
export const CALLING_REMOTE_COMPONENT_ID = 'calling-remote-app';
export const callingComponentDef = defineComponent(CALLING_COMPONENT, ({
  gates
}) => {
  const isUngatedForCallingRemoteWrapperRedesign = !!gates && gates.includes(CALLING_REDESIGN_GATE);
  return {
    name: CALLING_COMPONENT,
    path: `/calling-cross-tab-embed/${getPortalId()}/calling-remote-app`,
    capabilities: [capabilities.HIDE_COMPONENT_CAP.getName(), capabilities.SHOW_COMPONENT_CAP.getName(), capabilities.UPDATE_CALL_ICON_STATUS_CAP.getName(), capabilities.UPDATE_THIRD_PARTY_CALL_STATUS_CAP.getName(), capabilities.RESTYLE_CAP.getName(), capabilities.TOGGLE_CSAT_SURVEY_CAP.getName(), capabilities.TOGGLE_WOOTRIC_SURVEY_CAP.getName()],
    deferLoading: false,
    initiallyOpen: false,
    iframeProps: {
      id: CALLING_REMOTE_COMPONENT_ID,
      ['data-test-id']: CALLING_REMOTE_COMPONENT_ID,
      title: CALLING_REMOTE_COMPONENT_ID,
      style: {
        position: 'absolute',
        zIndex: Z_INDEX_NAV_COMPONENT_LOW,
        borderRadius: isUngatedForCallingRemoteWrapperRedesign ? '16px' : 0,
        boxShadow: isUngatedForCallingRemoteWrapperRedesign ? '0px 1px 5px 0px rgb(0, 0, 0, 0.12)' : 'none'
      }
    }
  };
});